module.exports = __webpack_public_path__ + "img/correct.1558aa5a.svg";